<div [formGroup]="filterFormGroup" class="personal-visit-filter no-field-space">
  <sc-flex [centered]="true">
    <mat-form-field class="grow" appearance="fill">
      <mat-label>{{'Filter' | translate: ['shared.tmc-table.filter', translationService.language]}}</mat-label>
      <input matInput [maxLength]="255" name="filterText" formControlName="filterText">
    </mat-form-field>
    <ng-container *ngFor="let item of scopeFilters">
      <sc-content-spacer [double]="true"></sc-content-spacer>
      <div class="additionalFilter" [ngClass]="{'selected': item.selected}" (click)="applyQuickFilter(item)">
        <span class="{{item.icon}}"
          [matTooltip]="'Filter' | translate: [item.title, translationService.language]"></span>
      </div>
    </ng-container>
    <sc-content-spacer [double]="true"></sc-content-spacer>
    <mat-form-field class="custom-filter-field" appearance="fill">
      <mat-label>
        {{'filter ' | translate: ['tmc.visit.overview.customFilter', translationService.language]}}
      </mat-label>
      <mat-select name="customFilter" formControlName="customFilter">
        <mat-option [value]="-1">
          {{ 'none' | translate: ['tmc.visit.overview.customFilter.option.none', translationService.language]}}
        </mat-option>
        <mat-option *ngFor="let filter of filters" [value]="filter.externalKey">
          {{filter.id | translate: [filter.dictionaryKey, translationService.language]}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </sc-flex>
</div>